import { useLoadNeuroID } from "@lending/hooks/useLoadNeuroID";
import { Institution } from "@lending/types";

interface LendingNeuroIDProps {
  institution: Institution;
}

function LendingNeuroID({ institution }: LendingNeuroIDProps) {
  useLoadNeuroID(institution);

  return null;
}

export default LendingNeuroID;
